import { Portal } from '../components/Portal';
import { frontConfig } from '../config';
import { usePermissions } from '../hooks/usePermissions';
import { isMobile } from '../utils/web';
import type { ThreadFooterEditorProps } from './ThreadFooterEditor/ThreadFooterEditor';
import { ThreadFooterEditor } from './ThreadFooterEditor/ThreadFooterEditor';

export const MobileThreadFooterEditor = (props: ThreadFooterEditorProps) => {
  const { isAuthDone, authUserId } = usePermissions();
  const shouldDisplayPortalFooter = isMobile() && isAuthDone && authUserId;

  return shouldDisplayPortalFooter ? (
    <Portal selector={frontConfig.rootElementSelector}>
      <ThreadFooterEditor {...props} />
    </Portal>
  ) : null;
};
